import { twclsx } from "../../utils/cssUtil";
import {
  CheckInStatus,
  EventStatusStyle,
  EventStatusToString,
} from "../../models/enum/checkInStatus";

export function CheckInStatusBadge({
  eventStatus,
}: {
  eventStatus?: CheckInStatus;
}) {
  if (!eventStatus) {
    return <></>;
  }

  return (
    <label className={twclsx("badge badge-sm", EventStatusStyle(eventStatus))}>
      {EventStatusToString(eventStatus)}
    </label>
  );
}
